import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

/*
 * @Author       : 程哲林
 * @Date         : 2022-08-08 14:38:11
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-10-28 12:07:46
 * @FilePath     : /marketing-landing-fe/src/modules/Login/index.ts
 * @Description  : 未添加文件描述
 */
import './index.less';
import { PRIVACY_PROTOCOL, USER_PROTOCOL } from '@/const'; // import dotRender from '@/helpers/dotRender';

import Toast from '@/plugins/Toast';
import { stringToDom } from '@/utils/dom';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';

var Login = function () {
  function Login(id) {
    if (id === void 0) {
      id = 'root';
    }

    this.template
    /* html */
    = "\n    <div class=\"login-wrap\">\n        <div class=\"login-content\">\n            <h3>\u4E3A\u7ED9\u60A8\u63D0\u4F9B\u66F4\u597D\u7684\u670D\u52A1</h3>\n            <p class=\"t1\">\u6211\u4EEC\u5C06\u5728\u5FC5\u8981\u573A\u666F\u4E0B\uFF0C\u5408\u7406\u4F7F\u7528\u60A8\u7684\u5FAE\u4FE1\u5934\u50CF\u3001\u6635\u79F0\u7B49\u4E2A\u4EBA\u4FE1\u606F\u5E76\u5145\u5206\u4FDD\u969C\u60A8\u7684\u5408\u6CD5\u6743\u5229</p>\n            <p class=\"t2\">\u53EF\u901A\u8FC7<a href=\"".concat(USER_PROTOCOL, "\">\u300A\u7528\u6237\u670D\u52A1\u534F\u8BAE\u300B</a>\u548C<a href=\"").concat(PRIVACY_PROTOCOL, "\">\u300A\u9690\u79C1\u534F\u8BAE\u300B</a>\u4E86\u89E3\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u3001\u5B58\u50A8\u548C\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u60C5\u51B5</p>\n            <div class=\"login-btn-wrap\">\n            <a sensors-disable='true' href=\"#url#\" class=\"btn-login\">\u540C\u610F\u5E76\u7EE7\u7EED</a>\n            <button sensors-disable='true' class=\"btn-exit\">\u62D2\u7EDD\u5E76\u9000\u51FA</button>\n            </div>\n        </div>\n    </div>\n  ");
    this.templateDom = null;
    this.$root = null;
    this.$root = document.getElementById(id);
  }

  Login.prototype.mount = function (cb) {
    var _this = this;

    var _a, _b;

    var $btnLogin = (_a = this.templateDom) === null || _a === void 0 ? void 0 : _a.querySelector('.btn-login');
    var $btnExit = (_b = this.templateDom) === null || _b === void 0 ? void 0 : _b.querySelector('.btn-exit');
    $btnLogin.addEventListener('click', function () {
      sensClickInitiative({
        $element_name: '投放落地页_登录提示弹窗_同意并继续',
        activity_label: '投放'
      });

      if (typeof cb === 'function') {
        cb('agree');
      }
    });
    $btnExit.addEventListener('click', function () {
      sensClickInitiative({
        $element_name: '投放落地页_登录提示弹窗_拒绝并退出',
        activity_label: '投放'
      });

      _this.hide();

      if (typeof cb === 'function') {
        cb('close');
      }
    });
  };

  Login.prototype.hide = function () {
    var _a; // 删除面板

    /* if (window?.wx) {
      window.wx?.closeWindow();
    } */


    (_a = this.templateDom) === null || _a === void 0 ? void 0 : _a.remove();
    this.templateDom = null;
  };

  Login.prototype.show = function (url, cb) {
    var _a;

    Toast.hide();
    var tmpDom = stringToDom(this.template.replace('#url#', url));
    (_a = this.$root) === null || _a === void 0 ? void 0 : _a.insertAdjacentElement('afterend', tmpDom);
    this.templateDom = tmpDom;
    this.mount(cb);
    sensElementView({
      c_element_name: '投放落地页_登录提示弹窗',
      activity_label: '投放'
    });
  };

  return Login;
}();

export default Login;